module.exports = __webpack_public_path__ + "img/depmap_svg_V86.80bd3108.svg";